export const headerDescription = `
We are a DevOps services company specializing in cloud infrastructure, CI/CD pipelines, 
and automation solutions. Our certified team helps businesses scale efficiently with 
AWS, GCP, Azure, Kubernetes, Docker, Terraform, and modern DevOps tools.
 `;

export const wordAnimation = ['DevOps', 'Cloud', 'Automation'];
